var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-recorder"},[_c('audio-recorder',{attrs:{"afterRecording":_vm.callback,"show-upload-button":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }